import { toUnicode } from 'punycode';
import { Flex } from '../../layout/Flex';
import { Image } from '../../media/Image';
import { Typography } from '../../typography/Typography';
import { FaviconCover } from './styles';
import { getPunycodeDomain } from './utils/getPunycodeDomain';
import type { ProductDomainProps } from './types';

export const ProductDomain = ({ domain, ...other }: ProductDomainProps) => {
    const domainText = domain ? toUnicode(domain) : '';
    const favicon =
        domain && `//favicon.yandex.net/favicon/v2/${getPunycodeDomain(domain)}?size=32&stub=1`;

    return (
        <Flex
            direction="row"
            alignItems="center"
            spacing={0.5}
            width="100%"
            overflow="hidden"
            {...other}
        >
            <Flex flexShrink={0}>
                <FaviconCover
                    ratio={1}
                    overflow="hidden"
                    borderRadius={3}
                    width="14px"
                    height="14px"
                >
                    <Image objectFit="contain" width="100%" height="100%" src={favicon} />
                </FaviconCover>
            </Flex>
            <Typography
                variant="caption"
                color="secondary"
                noWrap
                overflow="hidden"
                textOverflow="ellipsis"
            >
                {domainText}
            </Typography>
        </Flex>
    );
};
